import { render, staticRenderFns } from "./InvalidReason.vue?vue&type=template&id=71bcd122&scoped=true&"
import script from "./InvalidReason.vue?vue&type=script&lang=js&"
export * from "./InvalidReason.vue?vue&type=script&lang=js&"
import style0 from "./InvalidReason.vue?vue&type=style&index=0&id=71bcd122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bcd122",
  null
  
)

export default component.exports